var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { UNKNOWN_ENUM_VALUE, UserSsoState } from '@lucidlink/dto/validation';
import { useFormRoot } from '@lucidlink/uicore/form-builder';
import { LOGIN_WIZARD_STEPS, useGetUserSsoState, useSsoLogin, useSsoRegister, } from '@lucidlink/workspacemanagement';
import { useHandleSsoStateError } from '@lucidlink/workspacemanagement';
export const useLoginSsoKey = ({ accessToken, handleGeneralLoginError, loginEmail, resetLoginFlow, setNextStep, setSsoKey, }) => {
    _react_refresh_temp_1();
    const { formData } = useFormRoot();
    const { isPending: isSsoLoginInProgress, mutate: ssoLogin } = useSsoLogin({
        onError: handleGeneralLoginError,
    });
    const { isPending: isSsoRegisterInProgress, mutate: ssoRegister } = useSsoRegister({
        onError: handleGeneralLoginError,
        onSuccess: (params) => {
            ssoLogin({ ...params, loginEmail });
        },
    });
    const { data: userSsoState, error: userSsoStateError, isLoading: isLoadingUserSsoState, } = useGetUserSsoState({
        accessToken,
        email: loginEmail,
    });
    useHandleSsoStateError({
        userSsoStateError,
        handleGeneralLoginError,
        loginEmail,
        resetLoginFlow,
    });
    const onContinue = useCallback(() => {
        if (!formData.ssoKey) {
            return;
        }
        if (!userSsoState) {
            handleGeneralLoginError();
            return;
        }
        const { state: ssoState } = userSsoState;
        switch (ssoState) {
            case UserSsoState.NEEDS_MERGE:
                setSsoKey(formData.ssoKey);
                setNextStep(LOGIN_WIZARD_STEPS.MERGE);
                break;
            case UserSsoState.UNREGISTERED:
                ssoRegister({
                    accessToken,
                    domainSecret: formData.ssoKey,
                    loginEmail,
                });
                break;
            case UserSsoState.REGISTERED:
                ssoLogin({
                    accessToken,
                    domainSecret: formData.ssoKey,
                    loginEmail,
                });
                break;
            case UNKNOWN_ENUM_VALUE:
                break;
        }
    }, [
        accessToken,
        formData.ssoKey,
        handleGeneralLoginError,
        loginEmail,
        setNextStep,
        setSsoKey,
        ssoLogin,
        ssoRegister,
        userSsoState,
    ]);
    return {
        onContinue,
        isOperationInProgress: isSsoLoginInProgress || isSsoRegisterInProgress,
        isLoading: isLoadingUserSsoState,
    };
};
_react_refresh_temp_1(useLoginSsoKey, "7hKltC6fHHP2sNqKiEXVdgkheMI=", false, () => [useFormRoot, useSsoLogin, useSsoRegister, useGetUserSsoState, useHandleSsoStateError]);
